import { Link } from 'react-router-dom';
import './Home.css';

const WA = 'https://wa.me/34614807628?text=Hola!%20Quiero%20reservar%20un%20evento%20en%20NEON%20Music%20Cocktail';

export default function Eventos() {
  return (
    <main>
      <section className="nh-section" aria-labelledby="eventos-title">
        <div className="nh-section-head">
          <h1 id="eventos-title" className="nh-section-title">
            Eventos en NEON Music Cocktail
          </h1>
          <p className="nh-section-sub">
            Karaoke, cócteles, cocina y música para celebraciones en Alcalá de Henares.
          </p>
        </div>

        <div className="nh-highlights">
          <article className="nh-hl-card nh-hl-card-pink">
            <h2 className="nh-hl-title">Cumpleaños y grupos</h2>
            <p className="nh-hl-text">
              Reserva mesa para una noche con cocktails de firma, hamburguesas, raciones y ambiente musical.
            </p>
          </article>
          <article className="nh-hl-card nh-hl-card-cyan">
            <h2 className="nh-hl-title">Karaoke privado</h2>
            <p className="nh-hl-text">
              Planes para parejas, despedidas, grupos de amigos y celebraciones con karaoke en Alcalá de Henares.
            </p>
          </article>
          <article className="nh-hl-card nh-hl-card-teal">
            <h2 className="nh-hl-title">Eventos de empresa</h2>
            <p className="nh-hl-text">
              Cenas informales, afterworks y encuentros de equipo con cocina, copas y música.
            </p>
          </article>
        </div>

        <div className="nh-menu-preview" style={{ marginTop: '2rem' }}>
          <p className="nh-section-sub">
            Estamos en C. de la Coruña 16, 28805 Alcalá de Henares. Para reservar, llama al 614 80 76 28 o escríbenos por WhatsApp.
          </p>
          <div className="nh-hero-ctas">
            <a href={WA} target="_blank" rel="noreferrer" className="nh-btn nh-btn-primary">
              Reservar evento
            </a>
            <Link to="/carta" className="nh-btn nh-btn-secondary">
              Ver carta
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
